import React from 'react';
import {
  FiMail
} from 'react-icons/fi';

// Type assertion for the FiMail icon component
const FiMailComponent = FiMail as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

// Defines the props interface for the Cards component
interface CardsProps {
  subscribed: number;
  conversion: number;
  revenueGenerated: string;
  engagementScore: string;
}

// Renders a single statistic box with a label, value, and icon
const StatBox: React.FC<{ label: string; value: string | number }> = ({
  label,
  value,
}) => (
  <div className='bg-white rounded-md p-3 flex items-center justify-between border border-gray-200 shadow-sm'>
    <div>
      <h3 className='text-[#657584] text-[14px] mb-2 font-semibold'>{label}</h3>
      <p className='text-[28px] text-[#3F5265] font-semibold'>{value}</p>
    </div>
    <span className='flex items-center justify-center rounded-[5px] bg-[#FFF1EC] w-[30px] h-[30px]'>
      <FiMailComponent className='text-orange-500 text-2xl' size={17} />
    </span>
  </div>
);

// Renders a grid of statistic boxes displaying key metrics
const Cards: React.FC<CardsProps> = ({
  subscribed,
  conversion,
  revenueGenerated,
  engagementScore,
}) => {
  return (
    <div className='grid grid-cols-2 md:grid-cols-4 gap-4 mb-6'>
      <StatBox label='Subscribed' value={subscribed} />
      <StatBox label='Conversion' value={conversion} />
      <StatBox label='Revenue Generated' value={revenueGenerated} />
      <StatBox label='Engagement Score' value={engagementScore} />
    </div>
  );
};

export default Cards;
